<div class="w-full bg-white aarni-font shadow-lg mt-[80px]">
    <div class="container flex flex-col sm:flex-row justify-center sm:justify-between py-12 m-auto px-4">
        <h1 class="font-bold text-[32px] text-center sm:text-start">
            Contact Arni University
        </h1>
    </div>
</div>

<div class="my-12 mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6 container aarni-font">
    <div class="lg:col-span-2 bg-white p-6 shadow-md rounded-md">
        <img src="assets/img/iqac/internal-banner-iqac-desktop.webp" alt="University Campus"
             class="w-full h-60 object-cover rounded-md">

        <h2 class="text-xl font-bold mt-4">Arni University Campus</h2>
        <p class="text-gray-700">ARNI University, (Kathgarh), Tehsil Indora, Distt. Kangra, Himachal Pradesh - 176401,
            India</p>
        <p class="text-gray-700"><strong>Email:</strong> <a href="mailto:info@arniuniversity.edu.in"
                                                            class="text-blue-500"> info@arniuniversity.edu.in</a></p>
        <h3 class="text-lg font-semibold mt-6">Admission Enquiry</h3>
        <p class="text-gray-600">If you have any queries related to admission in any program at Arni University, feel
            free to contact us.</p>

        <h3 class="text-lg font-semibold mt-6">National Enquiry</h3>
        <p class="text-gray-600">Applicants living in India can get in touch with our team of counselors.</p>
        <p class="text-gray-700"><strong>Phone: </strong>
            +91-18008918962, +91-78-7685-9292, +91-9418601409</p>
        <p class="text-gray-700"><strong>Email:</strong> <a href="mailto:admissions@arniuniversity.edu.in"
                                                            class="text-blue-500"> admissions@arniuniversity.edu.in</a>
        </p>
        <p class="text-gray-700">
            <strong>WhatsApp:</strong>
            <a href="https://wa.me/917876500601" target="_blank" class="text-green-600 ">
                +91-7876500601
            </a>
        </p>
        <div class="overflow-x-auto mt-4 border">
            <table class="min-w-full divide-y divide-gray-200 text-center">
                <thead class="bg-green-50 text-center text-black font-bold text-xl">
                <tr class="divide-x divide-gray-200 ">
                    <th class="px-4 py-2 text-sm font-semibold text-gray-800">S.No</th>
                    <th class="px-4 py-2 text-sm font-semibold text-gray-800">Admission Office</th>
                    <th class="px-4 py-2 text-sm font-semibold text-gray-800">Owner's Name</th>
                    <th class="px-4 py-2 text-sm font-semibold text-gray-800">Contact</th>
                    <th class="px-4 py-2 text-sm font-semibold text-gray-800">Address</th>
                </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                <tr *ngFor="let row of contacts" class="divide-x divide-gray-200">
                    <td class="px-4 py-2 text-sm text-gray-800">{{ row.sno }}</td>
                    <td class="px-4 py-2 text-sm text-gray-800">{{ row.office }}</td>
                    <td class="px-4 py-2 text-sm text-gray-800">{{ row.owner }}</td>
                    <td class="px-4 py-2 text-sm text-gray-800">{{ row.contact }}</td>
                    <td class="px-4 py-2 text-sm text-gray-800">{{ row.address }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <h2 class="text-xl font-bold mt-4">International Office</h2>
        <p class="text-gray-700">International Office-Suite E-34, Al-hamsad Tower 1, Near Shoprite Mall, Zoo Road, Kano,
            Nigeria</p>
        <h3 class="text-lg font-semibold mt-6">International Enquiry</h3>
        <p class="text-gray-600">International applicants can contact our counselors.</p>
        <p class="text-gray-700"><strong>Phone:</strong> +919418601409, +2348164549176, +2349030848195</p>
        <p class="text-gray-700"><strong>Email:</strong> <a href="mailto:international.admission@arniuniversity.edu.in"
                                                            class="text-blue-500">
            international.admission@arniuniversity.edu.in</a></p>
        <!--<p class="text-gray-700"><strong>WhatsApp:</strong> +91-8800998881</p>-->
    </div>

    <div class="bg-primary-dark p-6 rounded-md shadow-md text-white mt-5 mx-4 md:mx-0 h-fit">
        <div *ngIf="formSubmitted" class="bg-green-500 text-white p-3 rounded mb-4 text-center font-semibold shadow">
            ✅ Your form has been submitted successfully!
        </div>
        <h3 class="text-xl font-semibold mb-4">Get in Touch</h3>
        <p class="text-gray-300 mb-4">Please fill out the form and we will contact you as soon as possible.</p>
        <form [formGroup]="applyNowForm">
            <input
                type="text"
                placeholder="Name *"
                class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                formControlName="name"
            />
            <input
                type="email"
                placeholder="Email *"
                class="w-full border p-2 mb-2 rounded bg-gray-100 text-black text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                formControlName="email"
            />
            <input
                type="tel"
                placeholder="Contact *"
                class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                formControlName="contact"
            />
            <select
                class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 text-black text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                formControlName="program_id"
                (change)="getCourses()"
            >
                <option value="">Select Program</option>
                <option *ngFor="let program of programs" [value]="program?.program?.id">
                    {{ program?.program?.name }}
                </option>
            </select>

            <div class="relative">
                <input
                    type="text"
                    (keyup)="filterCourses($event.target.value)"
                    (focus)="showCourseDropdown = true"
                    (blur)="hideDropdownWithDelay('COURSE')"
                    formControlName="selectedCourse"
                    placeholder="Select Course"
                    class="w-full border bg-gray-100 text-black border-blue-50 p-2 mb-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <ul
                    *ngIf="showCourseDropdown && filteredCourses?.length > 0"
                    class="absolute z-10 w-full bg-white border text-black border-blue-100 rounded shadow mt-1 max-h-[300px] h-[200px] overflow-y-scroll"
                >
                    <li
                        *ngFor="let course of filteredCourses"
                        (mousedown)="selectCourse(course)"
                        class="p-2 hover:bg-blue-100 text-black cursor-pointer"
                    >
                        {{ course?.course?.name || 'No Courses' }}
                    </li>
                </ul>
            </div>


            <div class="relative">
                <input
                    type="text"
                    (keyup)="filterBranch($event.target.value)"
                    (focus)="showBranchDropdown = true"
                    (blur)="hideDropdownWithDelay('BRANCH')"
                    formControlName="selectedBranch"
                    placeholder="Select Branch"
                    class="w-full border bg-gray-100 text-black border-blue-50 p-2 mb-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <ul
                    *ngIf="showBranchDropdown && filteredBranch?.length > 0"
                    class="absolute z-10 w-full bg-white border text-black border-blue-100 rounded shadow mt-1 max-h-[200px] h-[150px] overflow-y-scroll"
                >
                    <li
                        *ngFor="let branch of filteredBranch"
                        (mousedown)="selectBranch(branch)"
                        class="p-2 hover:bg-blue-100 text-black cursor-pointer"
                    >
                        {{ branch?.branch?.name || 'No Branches' }}
                    </li>
                </ul>
            </div>
            <button
                type="submit"
                class="w-full bg-green-600 text-white py-2 rounded font-bold hover:bg-green-700 transition duration-200 ease-in-out"
                (click)="submit()"
            >
                APPLY NOW
            </button>
        </form>
        <!--<form [formGroup]="contactForm">
            <input
                type="text"
                placeholder="Name *"
                class="w-full border border-blue-50 p-2 mb-2 rounded text-black bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                formControlName="name"
            />
            <input
                type="email"
                placeholder="Email *"
                class="w-full border p-2 mb-2 rounded bg-gray-100 text-black text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                formControlName="email"
            />
            <input
                type="tel"
                placeholder="Contact *"
                class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
                formControlName="contact"
            />

            <textarea
                placeholder="Remarks"
                formControlName="message"
                rows="4"
                class="w-full border border-blue-50 p-2 mb-4 resize-none rounded bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
            ></textarea>

            <button
                type="submit"
                class="w-full bg-green-600 text-white py-2 rounded font-bold hover:bg-green-700 transition duration-200 ease-in-out"
                (click)="submit()"
            >
                APPLY NOW
            </button>
        </form>-->
    </div>
</div>

<iframe
    class="object-cover w-full h-[600px]"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4079.2449613326!2d75.6576125761722!3d32.107942017877036!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391b833726246e79%3A0x3bf590ddee96ab2c!2sArni%20University!5e1!3m2!1sen!2sin!4v1743683832836!5m2!1sen!2sin"
    style="border:0;" allowfullscreen="" loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"></iframe>
